// // Dependencies
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery
window.jquery = jQuery

import Rails from '@rails/ujs'
if (!window._rails_loaded) Rails.start();
window.Rails = Rails
import "@hotwired/turbo-rails"

import magnificPopup from 'magnific-popup';
window.magnificPopup = magnificPopup

// require('../lib/bootstrap_3/alert')

// Scripts
import '../scripts/script_application'

